export default {
  title: 'Páginas',
  description: 'Gerencie as páginas dentro do website.',
  labels: {
    new: 'Nova Página',
  },
  form: {
    title: 'Cadastro de Página'
  },
  fields: {
    name: 'Nome da página',
    slug: 'Slug',
    url: 'URL',
    plan: 'Plano',
    max_depth: 'Limite de itens',
    page_type: 'Tipo de página',
    layout: 'Layout',
    is_published: 'Publicado',
    is_draft: 'Rascunho',
    status: 'Status',
    website: 'Website',
  }
};
